export default {
  get(context, params) {
    return new Promise((resolve, reject) => {
      const queryString = new URLSearchParams(params).toString();
      return window.axios
        .get(`/subscriptions?${queryString}`)
        .then(({ data: { results, count, next, previous } }) => {
          context.commit("setSubscriptions", results);
          context.commit("setPagination", {
            count,
            next,
            previous
          });
          resolve(results);
        })
        .catch(reject);
    });
  },
  getOverview(context, params) {
    return new Promise((resolve, reject) => {
      const queryString = new URLSearchParams(params).toString();
      return window.axios
        .get(`/subscriptions/reports/overview?${queryString}`)
        .then(({ data }) => {
          context.commit("setOverview", data);
          resolve(data);
        })
        .catch(reject);
    });
  },
  getCSV(context, params) {
    return new Promise((resolve, reject) => {
      const queryString = new URLSearchParams(params).toString();
      return window.axios
        .get(`/subscriptions?${queryString}`)
        .then(resolve)
        .catch(reject);
    });
  },
  requestChangeCard(context, id) {
    return new Promise((resolve, reject) => {
      window.axios
        .post(`/subscriptions/request-change-card/${id}`)
        .then(resolve)
        .catch(reject);
    });
  },
  changeCard(context, params) {
    return new Promise((resolve, reject) => {
      window.axios
        .post(`/subscriptions/change-card/${params.token}`, params)
        .then(resolve)
        .catch(reject);
    });
  },
  cancel(context, id) {
    return new Promise((resolve, reject) => {
      window.axios
        .post(`/subscriptions/cancel/${id}`)
        .then(resolve)
        .catch(reject);
    });
  },
  delete(context, id) {
    return new Promise((resolve, reject) => {
      window.axios
        .delete(`/subscriptions/${id}`)
        .then(resolve)
        .catch(reject);
    });
  }
};
